// Features: M004-F0799 (WebUI #263, slice C: the draft group switcher and share line)
// Tests: T-M004-0432 (draft selector, invoice_id on the ops, 409 re-read), T-M004-0433 (share line, customer visibility)
//
// Shared by the operator's draft page (LedgerQueueSections) and the customer's monthly draft (CustomerMonthlyDraft).
// Nothing here decides a draft: the Ledger picks the draft by invoice_id and answers 409 LEDGER_DRAFT_SELECTOR_REQUIRED when a
// customer has more than one open draft and no selector was sent. The page only sends the chosen invoice_id.
import { errorCode } from '../../services/billingProfileAdapter';

export const SELECTOR_REQUIRED = 'LEDGER_DRAFT_SELECTOR_REQUIRED';
// The sentence for the 409 (design §9.3), shared with the billing-profile model.
export const SELECTOR_SENTENCE = 'More than one draft is open for this customer. Choose which draft to use, then try again.';

export const isSelectorRequired = (error) => errorCode(error) === SELECTOR_REQUIRED;

// The drafts of a draft.list reply (payload.drafts), without any entry that has no invoice_id.
export const draftsOf = (payload) => (Array.isArray(payload?.drafts) ? payload.drafts : []).filter((d) => d && d.invoice_id);

// A selector is sent only when the customer has more than one open draft (design §9.2). One draft: nothing is sent.
export const selectorFor = (drafts, chosenInvoiceId) => (drafts.length > 1 && chosenInvoiceId ? { invoiceId: String(chosenInvoiceId) } : {});

// The draft to show: the current choice when it is still open, else the first open draft (null when there is none).
export const pickDraftId = (drafts, current) => (drafts.some((d) => String(d.invoice_id) === String(current)) ? String(current) : (drafts[0] ? String(drafts[0].invoice_id) : null));

// The bill-to DISPLAY NAME only (design §9.7): never an email, a phone or an address.
export const billToName = (draft) => (typeof draft?.bill_to?.display_name === 'string' ? draft.bill_to.display_name : '');
export const billToLine = (draft) => (billToName(draft) ? `Bill to: ${billToName(draft)}` : '');

// "part 1 of 2 of £100.00" from a line's share_of. index is 0-based on the wire, so the first part reads "part 1".
// The share is the Ledger's number; nothing is recomputed here.
export const shareText = (share) => {
  if (!share || typeof share !== 'object') return '';
  const total = Number(share.total_minor) / 100;
  return `part ${Number(share.index) + 1} of ${share.of} of £${total.toFixed(2)}`;
};
